<script setup lang="ts">
import { computed } from 'vue'

import clsx from 'clsx'

import BetaBaseImage from '@/components/beta-editor/BetaBaseImage.vue'

const props = defineProps<{
    element: any
    extra: any
    elementIndex: number
    isFull: boolean
    isNew?: boolean
    isEditable?: boolean
    schema?: any
}>()

const content = computed(() => props.element.frameContent || '')
const hasExtra = computed(() => props.extra != null)

const dynamicStyle = computed(() => {
    if (!hasExtra.value) return undefined

    const style: Record<string, string> = {
        margin: `${props.extra.margin?.top ?? 0}px ${props.extra.margin?.right ?? 0}px ${props.extra.margin?.bottom ?? 0}px ${props.extra.margin?.left ?? 0}px`,
        padding: `${props.extra.padding?.top ?? 0}px ${props.extra.padding?.right ?? 0}px ${props.extra.padding?.bottom ?? 0}px ${props.extra.padding?.left ?? 0}px`,
        maxWidth: '100%',
    }

    if (!props.extra.style_width_lock) style.width = props.extra.style?.width
    if (!props.extra.style_height_lock) style.height = props.extra.style?.height

    if (props.element.grid === 99 && content.value) {
        style.backgroundImage = `url(${import.meta.env.VITE_CDN_URL}/0x2400/${content.value})`
        style.backgroundSize = 'cover'
        style.backgroundPosition = '50% 50%'
    }

    return style
})

const dynamicSize = computed(() => {
    if (!hasExtra.value) return undefined

    const style: Record<string, string> = {}

    if (!props.extra.style_width_lock) style.width = props.extra.style?.width
    if (!props.extra.style_height_lock) style.height = props.extra.style?.height

    style.maxWidth = '100%'
    style.borderRadius = props.extra.style?.borderRadius

    return style
})
</script>

<template>
    <div
        tabindex="0"
        :id="'betaEditorImage-' + elementIndex"
        :style="dynamicStyle"
        :schema="JSON.stringify(schema)"
        :class="clsx('editor-image-beta', isFull && 'image-full')"
    >
        <beta-base-image
            class-name="editor-image-beta__image"
            :style="dynamicSize"
            :src="content"
            :alt="element.extra?.alt || 'Imagem'"
        />
    </div>
</template>

<style scoped>
.editor-image-beta {
    @apply relative flex min-w-0 max-w-full items-center justify-center overflow-hidden border-2 border-transparent bg-transparent outline-none transition-all duration-1000 ease-in-out hover:border-[#D7E3F4] hover:shadow-[0_0_0_2px_rgba(215,227,244,0.22)];
    box-sizing: border-box;
}

.editor-image-beta.image-full :deep(img) {
    @apply w-full max-w-full opacity-0;
}

.editor-image-beta__image {
    @apply w-full max-w-full object-cover;
}
</style>
